export default __webpack_public_path__ + "static/media/Bassy Incorrect.cbfd63a9.mp3";